import PropTypes from "prop-types"
import TradesPanel from "components/trades-panel"
import { TRADE } from "./shapes"

function ExperimentTrades({
  trades,
  setTradeType,
  tradeType,
  open,
  csvRows,
  onClose,
  openTradeId,
  fileName,
  setOpenTradeId,
  openSecurityProfile,
  experiment,
  selectedDate,
  status,
  openFactorProfile,
  toggleSaveExperiment,
}) {
  return <TradesPanel
    {...{
      selectedDate,
      portfolioName: experiment.label,
      status,
      fileName,
      setTradeType,
      csvRows,
      tradeType,
      trades,
      openSecurityProfile,
      setOpenTradeId,
      openTradeId,
      openFactorProfile,
      toggleTrades: onClose,
      tradesOpened: open,
      toggleSaveExperiment,
    }}
  />
}

ExperimentTrades.propTypes = {
  status: PropTypes.string.isRequired,
  trades: PropTypes.arrayOf(TRADE),
  tradeType: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  csvRows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))).isRequired,
  fileName: PropTypes.string.isRequired,
  openTradeId: PropTypes.string,
  setOpenTradeId: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  setTradeType: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  experiment: PropTypes.object.isRequired,
  selectedDate: PropTypes.string.isRequired,
  toggleSaveExperiment: PropTypes.func.isRequired,
}

export default ExperimentTrades
